

















































import Vue from "vue";
import $inoe from "@/config";
import { utils } from "../util";

export default Vue.extend({
  data() {
    return {
      dateValue: "",
      dateRange : $inoe.getDateRange(),
      minDate: "dateRange[-1]",
      maxDate: "dateRange[4]",
      resetDate : false,
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    dateTime: {
      type: String,
      default: "-1"
    }
  },
  methods: {
    clickQuit() {
      this.$emit("close-modal");
    },
    clickAccept() {
      this.$emit("click-accept", this.dateValue);
    }
  },
  mounted() {
    let date;
    this.dateTime === "" ? date = utils.getCurrentTimeNow().format("YYYY-MM-DD") : date = this.dateTime
    
    /*if (this.dateTime !== "-1") {
      date = utils.getDateFromString(this.dateTime, "YYYY-MM-DD HH:mm:ss");
    }*/
    
    this.dateValue = date;

    let current = utils.getCurrentTimeNow();
    let dateRangeString: string | null = $inoe.getDateRange();
    if (typeof dateRangeString !== "undefined" && dateRangeString !== null) {
      let splited = dateRangeString.split("#");
      this.minDate = utils.getDateWithAdding(parseInt(splited[0]));
      this.maxDate = utils.getDateWithAdding(parseInt(splited[1]));
    }
  }
});
